import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a06fcac"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-title"];
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "son"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "div_video"
};
const _hoisted_6 = {
  class: "div_title"
};
const _hoisted_7 = ["src", "poster", "autoplay", "muted"];
const _hoisted_8 = {
  class: "div_sub"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "data-title": $data.textTitle,
    class: "container",
    style: _normalizeStyle({
      background: 'url(' + $data.bgurl + ') no-repeat',
      backgroundSize: '100% 100%'
    })
  }, [$data.type ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.imgurl
  }, null, 8, _hoisted_4)])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($data.title), 1), _createElementVNode("video", {
    class: "video-js",
    controls: "",
    src: $data.mp4Url,
    poster: $data.cover,
    autoplay: $data.playStatus,
    muted: $data.muteStatus,
    ref: "videoPlayer"
  }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString($data.sub), 1)]))], 12, _hoisted_1);
}